<script>
    import Icon from '../../components/Icon.svelte';
    import { useNavigate } from 'svelte-navigator';
    import authStore from 'store/auth';
  import ButtonRounded from '../../common/ButtonRounded.svelte';

    const navigate = useNavigate();
    
    let contact = {
        name: "",
        email: "",
    }
    let event = ""
    let errors = {}
    let stages = [
        "start",
        "review",
        "thank-you"
    ]
    let stage = 0

    const isValidEmail = email => {
        const emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
        return emailRegex.test(email);
    }

    const review = () => {
        stage = 1;
        event = "loading";
        setTimeout(() => {
            stage = 2;
            event = ""
        }, 2000);
    }

    const initReview = () => {
        if (!contact.email || (contact.email && !isValidEmail(contact.email))) {
            errors.email = "Email is required";
            return
        }
        
        const user = $authStore.user
        const data = {
            ...contact,
            ...user
        }

        authStore.setUser(data);
        event = "loading";
        setTimeout(() => {
            stage = 1;
            event = "";
        }, 2000);
    }
    
</script>

<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="display-flex">
            <div class="flex flex-col">
                {#if stages[stage] === stages[0]}
                <div class="relative mx-8 my-16 text-gray-500">
                    <strong class="text-black text-lg">
                        Thank you for contacting us! 
                    </strong>
                    Please provide your email address below to receive a summary of the call.
                    <div class="mt-4">
                        <span class="text-xs">
                            Enter your email address
                        </span>
                        <div class="flex">
                            <input
                                placeholder="Enter your email"
                                bind:value={contact.email}
                                required
                                class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                            />
                            <ButtonRounded
                                disabled={false}
                                on:click={initReview}
                                size=8
                                title=""
                                icon="right-arrow"
                                iconColor="#30A059"
                                iconSize=16
                                className="bg-gradient-to-r from-cyan-500 to-blue-500 border border-blue-800 w-10 h-8"
                            />
                        </div>
                    </div>
                    {#if errors.email}
                        <small class="error">{ errors.email }</small>
                    {/if}
                </div>
                {/if}
                {#if stages[stage] === stages[1]}
                <div class="relative mx-8 mt-16 mb-8 text-gray-500">
                    <strong class="text-black text-xl">
                        We value your feedback
                    </strong>
                    Please rate your call experience below.

                    <div class="mt-4">
                        <span class="text-xs">
                            Write your review
                        </span>
                        <div class="flex">
                            <input
                                placeholder="Enter review"
                                bind:value={contact.review}
                                class="border-0 border-b border-black mr-2 px-2 py-1 text-sm"
                            />
                            <ButtonRounded
                                disabled={false}
                                on:click={review}
                                size=8
                                title=""
                                icon="right-arrow"
                                iconColor="#30A059"
                                iconSize=16
                                className="bg-gradient-to-r from-cyan-500 to-blue-500 border border-blue-800 w-10 h-8"
                            />
                        </div>
                        {#if errors.review}
                            <small class="error">{ errors.review }</small>
                        {/if}
                    </div>
                </div>
                {/if}
                {#if stages[stage] === stages[2]}
                <div class="relative flex flex-col justify-center items-center mx-8 my-16 text-gray-500 text-center">
                    <img src="images/icons/star.png" width="50px" alt="star">
                    <strong class="text-black">
                        Thank you for providing
                        your feedback!
                    </strong>
                    <br/>
                    <span class="text-xs">
                        We appreciate your input and strive to continuously improve our 
                        services based on your experience. We have also sent a summary of this call 
                        to your email.
                    </span>
                    <ButtonRounded
                        disabled={false}
                        on:click={() => navigate("/")}
                        size=8
                        title=""
                        className="bg-gradient-to-r from-cyan-500 to-blue-500 border border-blue-800 h-10 mt-4 flex-inline text-white px-8"
                    >
                    Return home
                    </ButtonRounded>

                </div>
                {/if}
                {#if event !== ""}
                <div class="flex mx-1">
                    <span class={`${event === "loading" ? "animate-spin" : ""} mx-2`}>
                        <Icon icon={event} size={24} color="#30A059" />
                    </span>
                    <span class="mx-2">
                        {#if event === "loading"}
                            Connecting.
                        {:else}
                            Ringing.
                        {/if}
                    </span>
                </div>
                {/if}
            </div>
        </div>

    </div>
</div>

<style lang="scss">
</style>